import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
// layout
import Layout from '@/layout';
import Vue from 'vue';
import VueRouter from 'vue-router';
var originalPush = VueRouter.prototype.push;
var originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};

VueRouter.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(function (err) {
    return err;
  });
};

Vue.use(VueRouter);
/**
 * Note: sub-menu only appear when route children.length >= 1
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */

export var constantRoutes = [{
  path: '/login',
  name: 'Login',
  component: function component() {
    return import('@/views/entranceCommon/login/index');
  },
  hidden: true
}, {
  path: '/',
  component: Layout,
  redirect: '/basicInformation',
  hidden: true
}, {
  path: '/register',
  name: 'Register',
  component: function component() {
    return import('@/views/entranceCommon/register/index');
  },
  hidden: true
}, {
  path: '/audit',
  name: 'Audit',
  component: function component() {
    return import('@/views/entranceCommon/audit/index');
  },
  hidden: true
}, {
  path: '/agreement',
  name: 'Agreement',
  component: function component() {
    return import('@/views/entranceCommon/agreement/index');
  },
  hidden: true
}, {
  path: '/forget',
  name: 'Forget',
  component: function component() {
    return import('@/views/entranceCommon/forget/index');
  },
  hidden: true
}, {
  path: '/401',
  component: function component() {
    return import('@/views/error-page/401');
  },
  hidden: true
}];
/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */

export var asyncRoutes = [{
  path: '/basicInformation',
  name: 'BasicInformation',
  component: Layout,
  redirect: '/basicInformation/home',
  meta: {
    title: '基础信息管理',
    breadcrumb: false,
    roles: ['BasicModule']
  },
  children: [{
    path: 'home',
    name: 'BasicInformationHome',
    component: function component() {
      return import('@/views/basicInformation/home/');
    },
    hidden: true,
    meta: {
      title: '首页'
    }
  }, {
    path: 'useGuide',
    name: 'useGuide',
    component: function component() {
      return import('@/views/entranceCommon/useGuide/index');
    },
    hidden: true,
    meta: {
      title: '使用手册'
    }
  }, {
    path: 'accountManage',
    name: 'AccountManage',
    component: function component() {
      return import('@/views/basicInformation/accountManage/');
    },
    meta: {
      title: '账号及权限管理',
      icon: 'nav_account',
      roles: ['BasicInfo']
    },
    children: [{
      path: 'organizationManage',
      name: 'OrganizationManage',
      component: function component() {
        return import('@/views/basicInformation/accountManage/organizationManage/index.vue');
      },
      redirect: '/basicInformation/accountManage/organizationManage',
      meta: {
        title: '组织管理',
        roles: ['OrganizationManage']
      },
      children: [{
        path: '',
        name: 'OrganizationManageList',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/organizationManage/list.vue');
        },
        meta: {
          title: '组织管理列表',
          roles: ['OrganizationManage', 'OrgManageList'],
          breadcrumb: false,
          activeMenu: '/basicInformation/accountManage/organizationManage'
        }
      }, {
        path: 'createStoreManage',
        name: 'CreateStoreManage',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/organizationManage/edit.vue');
        },
        meta: {
          title: '新建门店',
          roles: ['createManage'],
          activeMenu: '/basicInformation/accountManage/organizationManage'
        }
      }, {
        path: 'createDepartManage',
        name: 'CreateDepartManage',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/organizationManage/edit.vue');
        },
        meta: {
          title: '新建部门',
          roles: ['createManage'],
          activeMenu: '/basicInformation/accountManage/organizationManage'
        }
      }, {
        path: 'editOrgManage/:orgCode',
        name: 'EditOrgManage',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/organizationManage/edit.vue');
        },
        meta: {
          title: '组织信息',
          roles: ['EditOrgManage'],
          activeMenu: '/basicInformation/accountManage/organizationManage'
        }
      }, {
        path: 'detailOrgManage/:orgCode',
        name: 'DetailOrgManage',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/organizationManage/detail.vue');
        },
        meta: {
          title: '组织详情',
          roles: ['OrgManageList'],
          activeMenu: '/basicInformation/accountManage/organizationManage'
        }
      }]
    }, {
      path: 'roleManage',
      name: 'RoleManage',
      component: function component() {
        return import('@/views/basicInformation/accountManage/roleManage/index.vue');
      },
      redirect: '/basicInformation/accountManage/roleManage',
      meta: {
        title: '角色管理',
        roles: ['RoleManage']
      },
      children: [{
        path: '',
        name: 'RoleManageList',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/roleManage/list.vue');
        },
        meta: {
          title: '角色管理',
          roles: ['RoleManage', 'CreateRoleManage', 'EditRoleManage'],
          breadcrumb: false
        }
      }, {
        path: 'createRoleManage',
        name: 'CreateRoleManage',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/roleManage/edit.vue');
        },
        meta: {
          title: '新建角色',
          roles: ['CreateRoleManage'],
          activeMenu: '/basicInformation/accountManage/roleManage'
        }
      }, {
        path: 'editRoleManage/:roleCode',
        name: 'EditRoleManage',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/roleManage/edit.vue');
        },
        meta: {
          title: '编辑角色',
          roles: ['EditRoleManage'],
          activeMenu: '/basicInformation/accountManage/roleManage'
        }
      }, {
        path: 'detailRoleManage/:roleCode/:updateTime?/:updateUser?',
        name: 'DetailRoleManage',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/roleManage/detail.vue');
        },
        meta: {
          title: '角色详情',
          roles: ['RoleManageSearch'],
          activeMenu: '/basicInformation/accountManage/roleManage'
        }
      }]
    }, {
      path: 'postManage',
      name: 'PostManage',
      component: function component() {
        return import('@/views/basicInformation/accountManage/postManage/index.vue');
      },
      redirect: '/basicInformation/accountManage/postManage',
      meta: {
        title: '岗位信息',
        roles: ['RoleManage']
      },
      children: [{
        path: '',
        name: 'PostManageList',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/postManage/list.vue');
        },
        meta: {
          title: '岗位信息列表',
          roles: ['RoleManage', 'PostManageList'],
          breadcrumb: false
        }
      }, {
        path: 'detailPostManage',
        name: 'DetailPostManage',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/postManage/detail.vue');
        },
        meta: {
          title: '岗位详情',
          roles: ['PostManageList'],
          activeMenu: '/basicInformation/accountManage/postManage'
        }
      }]
    }, {
      path: 'employeeManage',
      name: 'EmployeeManage',
      component: function component() {
        return import('@/views/basicInformation/accountManage/employeeManage/index.vue');
      },
      redirect: '/basicInformation/accountManage/employeeManage',
      meta: {
        title: '员工管理',
        roles: ['employeeManage']
      },
      children: [{
        path: '',
        name: 'EmployeeManageList',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/employeeManage/list.vue');
        },
        meta: {
          title: '员工管理列表',
          roles: ['employeeManage'],
          breadcrumb: false,
          activeMenu: '/basicInformation/accountManage/employeeManage'
        }
      }, {
        path: 'createEmployeeManage/:isEdit',
        name: 'CreateEmployeeManage',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/employeeManage/edit.vue');
        },
        meta: {
          title: '新建员工账号',
          roles: ['CreateEmployeeManage'],
          activeMenu: '/basicInformation/accountManage/employeeManage'
        }
      }, {
        path: 'editEmployeeManage/:isEdit/:userCode/:orgName',
        name: 'EditEmployeeManage',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/employeeManage/edit.vue');
        },
        meta: {
          title: '编辑员工账号',
          roles: ['EditEmployeeManage'],
          activeMenu: '/basicInformation/accountManage/employeeManage'
        }
      }, {
        path: 'detailEmployeeManage/:userCode/:orgName',
        name: 'DetailEmployeeManage',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/accountManage/employeeManage/edit.vue');
        },
        meta: {
          title: '员工账号详情',
          roles: ['employeeMList'],
          activeMenu: '/basicInformation/accountManage/employeeManage'
        }
      }]
    }]
  }, {
    path: 'goodsLibrary',
    name: 'GoodsLibrary1',
    component: function component() {
      return import('@/views/basicInformation/goodsLibrary/index.vue');
    },
    redirect: '/basicInformation/goodsLibrary/list',
    meta: {
      title: '财务管理',
      icon: 'nav_goodsLibrary',
      roles: ['GoodsLibrary1']
    },
    children: [{
      hidden: true,
      path: 'list',
      name: 'GoodsLibraryList',
      component: function component() {
        return import('@/views/basicInformation/goodsLibrary/list.vue');
      },
      meta: {
        title: '商品库列表',
        roles: ['GoodsLibrary1', 'GoodsLibraryPetchAdd', 'GoodsLibraryAdd', 'GoodsLibraryBetchDelete', 'GoodsLibraryOnsale', 'GoodsLibrarySubmit', 'GoodsLibraryEdit1', 'GoodsLibraryDelete'],
        breadcrumb: false,
        activeMenu: '/basicInformation/goodsLibrary'
      }
    }, {
      hidden: true,
      path: 'editGood',
      name: 'GoodsLibraryAdd',
      component: function component() {
        return import('@/views/basicInformation/goodsLibrary/editGood.vue');
      },
      meta: {
        title: '手动新建',
        roles: ['GoodsLibraryAdd'],
        activeMenu: '/basicInformation/goodsLibrary'
      }
    }, {
      hidden: true,
      path: 'editGood',
      name: 'GoodsLibraryEdit1',
      component: function component() {
        return import('@/views/basicInformation/goodsLibrary/editGood.vue');
      },
      meta: {
        title: '编辑',
        roles: ['GoodsLibraryEdit1'],
        activeMenu: '/basicInformation/goodsLibrary'
      }
    }, {
      hidden: true,
      path: 'scanningGunAddGoods',
      name: 'ScanningGunAddGoods',
      component: function component() {
        return import('@/views/basicInformation/goodsLibrary/scanningGunAddGoods.vue');
      },
      meta: {
        title: '新建商品',
        roles: ['GoodsLibraryAdd'],
        activeMenu: '/basicInformation/goodsLibrary'
      }
    }, {
      hidden: true,
      path: 'newCreateGoodsLibrar',
      name: 'newCreateGoodsLibrar',
      component: function component() {
        return import('@/views/basicInformation/goodsLibrary/newCreateGoodsLibrar.vue');
      },
      meta: {
        title: '新建商品',
        roles: ['newCreateGoodsLibrar'],
        activeMenu: '/onlineStore/basicInfo/goodsLibrary'
      }
    }, {
      hidden: true,
      path: 'goodsDetail',
      name: 'GoodsLibraryDetail',
      component: function component() {
        return import('@/views/onlineStore/storeOperations/goodsList/goodsDetail.vue');
      },
      meta: {
        title: '商品详情',
        roles: ['GoodsLibrary', 'GoodsLibraryDetail'],
        activeMenu: '/basicInformation/goodsLibrary'
      }
    }]
  }, {
    path: 'businessInfo',
    name: 'BusinessInfo',
    component: function component() {
      return import('@/views/basicInformation/businessInfo/index.vue');
    },
    meta: {
      title: '企业管理',
      icon: 'nav_business',
      roles: ['BusinessInfo']
    }
  }, {
    path: 'storeInfo',
    name: 'StoreInfo',
    redirect: '/basicInformation/storeInfo',
    component: function component() {
      return import('@/views/basicInformation/storeInfo/index.vue');
    },
    meta: {
      title: '财务管理',
      icon: 'nav_store',
      roles: ['StoreInfo']
    },
    children: [{
      path: '',
      name: 'StoreInfoList',
      hidden: true,
      component: function component() {
        return import('@/views/basicInformation/storeInfo/list.vue');
      },
      meta: {
        title: '门店信息列表',
        roles: ['StoreInfo'],
        breadcrumb: false
      }
    }, {
      path: 'createStoreInfoList/:isEdit',
      name: 'CreateStoreInfoList',
      hidden: true,
      component: function component() {
        return import('@/views/basicInformation/storeInfo/edit.vue');
      },
      meta: {
        title: '新建门店',
        roles: ['CreateStoreInfoList'],
        activeMenu: '/basicInformation/storeInfo'
      }
    }, {
      path: 'editStoreInfoList/:isEdit/:storeCode',
      name: 'EditStoreInfoList',
      hidden: true,
      component: function component() {
        return import('@/views/basicInformation/storeInfo/edit.vue');
      },
      meta: {
        title: '修改门店信息',
        roles: ['EditStoreInfoList'],
        activeMenu: '/basicInformation/storeInfo'
      }
    }, {
      path: 'detailStoreInfoList/:storeCode?',
      name: 'DetailStoreInfoList',
      hidden: true,
      component: function component() {
        return import('@/views/basicInformation/storeInfo/edit.vue');
      },
      meta: {
        title: '门店详情',
        roles: ['StoreInfo', 'DetailStoreInfo'],
        activeMenu: '/basicInformation/storeInfo'
      }
    }, {
      path: 'detailStoreEshop/:storeCode/:storeName?',
      name: 'DetailStoreEshop',
      hidden: true,
      component: function component() {
        return import('@/views/basicInformation/storeInfo/eshop.vue');
      },
      meta: {
        title: '网店状态详情',
        roles: ['StoreInfo', 'DetailStoreEshop'],
        activeMenu: '/basicInformation/storeInfo'
      }
    }]
  }, {
    path: 'memberManage',
    name: 'MemberManage',
    component: function component() {
      return import('@/views/basicInformation/memberManage');
    },
    meta: {
      title: '会员管理',
      icon: 'nav_member',
      roles: ['MemberManage']
    },
    alwaysShow: true,
    children: [{
      path: 'list',
      name: 'MemberManageList',
      component: function component() {
        return import('@/views/basicInformation/memberManage/baseInfo/index.vue');
      },
      meta: {
        title: '会员查询',
        roles: ['MemberManage']
      },
      children: [{
        path: '/basicInformation/memberManage/list/coupon/:userCode/:storeCode',
        name: 'MemberManageCoupon',
        hidden: true,
        component: function component() {
          return import('@/views/basicInformation/memberManage/baseInfo/couponQuery.vue');
        },
        meta: {
          title: '优惠券查询',
          roles: ['MemberManage'],
          activeMenu: '/basicInformation/memberManage/list'
        }
      }]
    }]
  }]
}, {
  path: '/onlineStore',
  name: 'OnlineStore',
  component: Layout,
  redirect: '/onlineStore/home',
  meta: {
    title: '园区管理',
    breadcrumb: false,
    roles: ['EcommerceModule']
  },
  children: [{
    path: 'home',
    name: 'OnlineStoreHome',
    component: function component() {
      return import('@/views/onlineStore/home/');
    },
    meta: {
      title: '首页',
      icon: 'nav_home'
    },
    children: [{
      path: 'saleList',
      component: function component() {
        return import('@/views/onlineStore/home/saleList.vue');
      },
      hidden: true,
      name: 'SaleListHome',
      meta: {
        title: '园区租售榜单',
        icon: 'nav_home',
        roles: ['PageOnlineStoreHomeGoodsList'],
        activeMenu: '/onlineStore/home'
      }
    }, {
      path: 'payList',
      component: function component() {
        return import('@/views/onlineStore/home/payList.vue');
      },
      hidden: true,
      name: 'PayListHome',
      meta: {
        title: '会员累计支付榜单',
        icon: 'nav_home',
        roles: ['OnlineStoreHome'],
        activeMenu: '/onlineStore/home'
      }
    }]
  }, // 店铺运营
  {
    path: 'storeOperations',
    name: 'StoreOperations',
    component: function component() {
      return import('@/views/onlineStore/storeOperations');
    },
    meta: {
      title: '园区运营',
      icon: 'nav_shop',
      roles: ['StoreOperations']
    },
    children: [{
      path: 'programGoods',
      name: 'ProgramGoods',
      component: function component() {
        return import('@/views/onlineStore/storeOperations/parkList/index.vue');
      },
      redirect: '/onlineStore/storeOperations/programGoods/list',
      meta: {
        title: '园区管理',
        roles: ['ProgramGoods', 'GoodsLibrary']
      },
      children: [{
        hidden: true,
        path: 'list',
        name: 'ProgramGoodsList',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/parkList/list.vue');
        },
        meta: {
          title: '园区列表',
          roles: ['ProgramGoods', 'ParkLibrary', 'GoodsLibraryPetchAdd', 'ParkLibraryAdd', 'GoodsLibraryOnsale', 'GoodsLibrarySubmit', 'GoodsLibraryEdit', 'GoodsLibraryDelete'],
          breadcrumb: false,
          activeMenu: '/onlineStore/storeOperations/parkList'
        }
      }, {
        hidden: true,
        path: 'editGood',
        name: 'GoodsLibraryEdit',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/parkList/editGood.vue');
        },
        meta: {
          title: '编辑',
          roles: ['ProgramGoods', 'GoodsLibraryEdit'],
          activeMenu: '/storeOperations/parkList'
        }
      }, {
        hidden: true,
        path: 'ParkLibraryAdd',
        name: 'ParkLibraryAdd',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/parkList/editGood.vue');
        },
        meta: {
          title: '新建园区',
          roles: ['ProgramGoods', 'ParkLibraryAdd', 'GoodsLibraryAdd'],
          activeMenu: '/storeOperations/parkList'
        }
      }, {
        hidden: true,
        path: 'newCreateGoodsLibrar',
        name: 'newCreateGoodsLibrar',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/parkList/editGood.vue');
        },
        meta: {
          title: '新建园区',
          roles: ['ProgramGoods', 'newCreateGoodsLibrar'],
          activeMenu: '/storeOperations/parkList'
        }
      }, {
        hidden: true,
        path: 'goodsDetail',
        name: 'GoodsLibraryDetail',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/parkList/parkDetail.vue');
        },
        meta: {
          title: '商品详情',
          roles: ['GoodsLibrary', 'GoodsLibraryDetail'],
          activeMenu: '/basicInformation/goodsLibrary'
        }
      }]
    }, {
      path: 'operationSet',
      name: 'OperationSet',
      component: function component() {
        return import('@/views/onlineStore/storeOperations/operationSet/index.vue');
      },
      redirect: '/onlineStore/storeOperations/operationSet/list',
      meta: {
        title: '新闻配置',
        roles: ['OperationSet']
      },
      children: [{
        hidden: true,
        path: 'list',
        name: 'OperationSetList',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/operationSet/list.vue');
        },
        meta: {
          title: '新闻配置',
          roles: ['OperationSet', 'btn_statusDetail', // 经营状态tab
          'btn_setDetail', // 接单配置tab
          'btn_setDetailUpdate', // 修改接单配置按钮
          'btn_statusDetailUpdate' // 修改经营状态按钮
          ],
          activeMenu: '/onlineStore/storeOperations/operationSet',
          breadcrumb: false
        }
      }, {
        hidden: true,
        path: 'addGoods',
        name: 'GoodsLibraryEdit',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/operationSet/operateDialog/addGoods.vue');
        },
        meta: {
          title: '添加',
          roles: ['addNews'],
          //'ProgramGoods','GoodsLibraryEdit',
          activeMenu: '/storeOperations/operationSet'
        }
      }]
    }, {
      path: 'enterpriseManager',
      name: 'EnterpriseManager',
      component: function component() {
        return import('@/views/onlineStore/storeOperations/enterpriseManager/index.vue');
      },
      redirect: '/onlineStore/storeOperations/enterpriseManager/list',
      meta: {
        title: '园区企业管理',
        roles: ['EnterpriseManager']
      },
      children: [{
        hidden: true,
        path: 'list',
        name: 'EnterpriseManagerList',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/enterpriseManager/list.vue');
        },
        meta: {
          title: '企业列表',
          roles: ['EnterpriseManager', 'EnterpriseManagerList', // 经营状态tab
          'EnterpriseEdit', // 接单配置tab
          'EnterpriseDelete', // 修改接单配置按钮
          'btn_statusDetailUpdate' // 修改经营状态按钮
          ],
          activeMenu: '/onlineStore/storeOperations/enterpriseManager',
          breadcrumb: false
        }
      }, {
        hidden: true,
        path: 'editEnterprise',
        name: 'EnterpriseEdit',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/enterpriseManager/editEnterprise.vue');
        },
        meta: {
          title: '编辑',
          roles: ['EnterpriseManager', 'EnterpriseEdit'],
          activeMenu: '/storeOperations/enterpriseManager'
        }
      }, {
        hidden: true,
        path: 'EnterpriseAdd',
        name: 'EnterpriseAdd',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/enterpriseManager/editEnterprise.vue');
        },
        meta: {
          title: '新建企业',
          roles: ['EnterpriseManager', 'EnterpriseAdd'],
          activeMenu: '/storeOperations/enterpriseManager'
        }
      }]
    }, {
      path: 'contractManager',
      name: 'ContractManager',
      component: function component() {
        return import('@/views/onlineStore/storeOperations/contractManager/index.vue');
      },
      redirect: '/onlineStore/storeOperations/contractManager/list',
      meta: {
        title: '合同管理',
        roles: ['ContractManager']
      },
      children: [{
        hidden: true,
        path: 'list',
        name: 'ContractManagerList',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/contractManager/list.vue');
        },
        meta: {
          title: '合同列表',
          roles: ['ContractManager', 'ContractManagerList', 'ContractManagerEdit', 'ContractDelete', 'ContractManagerAdd', 'ContractDetail', 'ContractManagerRent'],
          activeMenu: '/onlineStore/storeOperations/contractManager',
          breadcrumb: false
        }
      }, {
        hidden: true,
        path: 'editContract',
        name: 'ContractManagerEdit',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/contractManager/editContract.vue');
        },
        meta: {
          title: '编辑',
          roles: ['ContractManager', 'ContractManagerEdit'],
          activeMenu: '/storeOperations/contractManager'
        }
      }, {
        hidden: true,
        path: 'ContractManagerAdd',
        name: 'ContractManagerAdd',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/contractManager/editContract.vue');
        },
        meta: {
          title: '新建合同',
          roles: ['ContractManager', 'ContractManagerAdd'],
          activeMenu: '/storeOperations/contractManager'
        }
      }, {
        hidden: true,
        path: 'contractDetail',
        name: 'ContractDetail',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/contractManager/contractDetail.vue');
        },
        meta: {
          title: '合同详情',
          roles: ['ContractDetail'],
          activeMenu: '/onlineStore/storeOperations/contractManager'
        }
      }, {
        hidden: true,
        path: 'contractRent',
        name: 'ContractManagerRent',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/contractManager/rent.vue');
        },
        meta: {
          title: '收租金',
          roles: ['ContractManager', 'ContractManagerRent'],
          activeMenu: '/onlineStore/storeOperations/contractManager'
        }
      }]
    }, {
      path: 'freightFormwork',
      name: 'FreightFormwork',
      component: function component() {
        return import('@/views/onlineStore/storeOperations/freightFormwork/index.vue');
      },
      redirect: '/onlineStore/storeOperations/freightFormwork/distributeWay',
      meta: {
        title: '水电费管理',
        roles: ['FreightFormwork']
      },
      children: [{
        hidden: true,
        path: 'distributeWay',
        name: 'DistributeWay',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/freightFormwork/distributeWay.vue');
        },
        meta: {
          title: '配送方式',
          roles: ['StoreOperations', 'FreightFormwork', 'DistributeWay'],
          activeMenu: '/onlineStore/storeOperations/freightFormwork',
          breadcrumb: false
        }
      }, {
        hidden: true,
        path: 'templateList',
        name: 'DistributeWayList',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/freightFormwork/templateList.vue');
        },
        meta: {
          title: '模板列表',
          roles: ['DistributeWayList', 'tab_hospitalAdd', 'tab_mall', 'tab_program', 'tab_hospitalUpdate', 'tab_mallUpdate', 'tab_programUpdate', 'tab_hospitalSetStatus', 'tab_mallSetStatus', 'tab_programSetStatus', 'tab_hospitalDelete', 'tab_mallDelete', 'tab_programDelete'],
          activeMenu: '/onlineStore/storeOperations/freightFormwork'
        }
      }, {
        hidden: true,
        path: 'detail',
        name: 'DistributeWayDetail',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/freightFormwork/detail.vue');
        },
        meta: {
          title: '模板详情',
          roles: ['StoreOperations', 'FreightFormwork', 'DistributeWayDetail'],
          activeMenu: '/onlineStore/storeOperations/freightFormwork'
        }
      }, // 新建运费模板
      {
        hidden: true,
        path: 'carriageTemplate',
        name: 'NewCarriageTemplate',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/freightFormwork/carriageTemplate.vue');
        },
        meta: {
          title: '新建',
          roles: ['StoreOperations', 'FreightFormwork', 'NewCarriageTemplate'],
          activeMenu: '/onlineStore/storeOperations/freightFormwork'
        }
      }, // 编辑运费模板
      {
        hidden: true,
        path: 'carriageTemplate',
        name: 'CarriageTemplate',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/freightFormwork/carriageTemplate.vue');
        },
        meta: {
          title: '编辑',
          roles: ['StoreOperations', 'FreightFormwork', 'CarriageTemplate'],
          activeMenu: '/onlineStore/storeOperations/freightFormwork'
        }
      }]
    }, {
      path: 'accountInfo',
      name: 'AccountInfo',
      component: function component() {
        return import('@/views/onlineStore/storeOperations/accountInfo/index.vue');
      },
      redirect: '/onlineStore/storeOperations/accountInfo/list',
      meta: {
        title: '结账单',
        roles: ['AccountInfo']
      },
      children: [{
        hidden: true,
        path: 'list',
        name: 'AccountInfoList',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/accountInfo/list.vue');
        },
        meta: {
          title: '结账单列表',
          roles: ['AccountInfo', 'AccountInfoList'],
          activeMenu: '/onlineStore/storeOperations/accountInfo',
          breadcrumb: false
        }
      }, {
        hidden: true,
        path: 'detail',
        name: 'AccountInfoDetail',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/accountInfo/detail.vue');
        },
        meta: {
          title: '查看明细',
          roles: ['AccountInfo', 'AccountInfoDetail'],
          activeMenu: '/onlineStore/storeOperations/accountInfo'
        }
      }]
    }, {
      path: 'storeFixture',
      name: 'StoreFixture',
      component: function component() {
        return import('@/views/onlineStore/storeOperations/storeFixture/index.vue');
      },
      redirect: '/onlineStore/storeOperations/storeFixture/list',
      meta: {
        title: '企业合同',
        roles: ['StoreFixture']
      },
      children: [{
        hidden: true,
        path: 'list',
        name: 'StoreFixtureList',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/storeFixture/list.vue');
        },
        meta: {
          title: '店铺装修列表',
          roles: ['StoreFixture', 'storeFixtureList'],
          activeMenu: '/onlineStore/storeOperations/storeFixture',
          breadcrumb: false
        }
      }, {
        hidden: true,
        path: 'adsSet',
        name: 'StoreFixtureAdsSet',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/storeFixture/adsSet.vue');
        },
        meta: {
          title: '广告位',
          roles: ['StoreFixtureAdsSet'],
          activeMenu: '/onlineStore/storeOperations/storeFixture'
        }
      }, {
        hidden: true,
        path: 'fastEntrySet',
        name: 'StoreFixtureFastEntrySet',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/storeFixture/fastEntrySet.vue');
        },
        meta: {
          title: '快捷入口',
          roles: ['StoreFixtureFastEntrySet'],
          activeMenu: '/onlineStore/storeOperations/storeFixture'
        }
      }, {
        hidden: true,
        path: 'drawerSet',
        name: 'StoreFixtureDrawerSet',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/storeFixture/drawerSet.vue');
        },
        meta: {
          title: '抽屉',
          roles: ['StoreFixtureDrawerSet'],
          activeMenu: '/onlineStore/storeOperations/storeFixture'
        }
      }]
    }, {
      path: 'hospitalGoods',
      name: 'HospitalGoods',
      component: function component() {
        return import('@/views/onlineStore/storeOperations/rentSale/index.vue');
      },
      redirect: '/onlineStore/storeOperations/hospitalGoods/list',
      meta: {
        title: '园区租售管理',
        roles: ['HospitalGoods']
      },
      children: [{
        hidden: true,
        path: 'list/:type?',
        name: 'HospitalGoodsList',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/rentSale/list.vue');
        },
        meta: {
          title: '园区租售信息列表',
          roles: ['HospitalGoods', 'RentSaleAdd', 'HospitalGoodsListPetchUp', 'HospitalGoodsPetchDown', 'HospitalGoodsUp', 'HospitalGoodsDown', 'HospitalGoodsListAddGoods', 'HospitalGoodsListAddMenuClassify', 'GoodsLibraryDetail'],
          breadcrumb: false,
          activeMenu: '/onlineStore/storeOperations/rentSale'
        }
      }, {
        hidden: true,
        path: 'HospitalGoodsListAddGoods',
        name: 'HospitalGoodsListAddGoods',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/rentSale/newCreateGoodsLibrar.vue');
        },
        meta: {
          title: '新建租售信息',
          roles: ['HospitalGoodsListAddGoods'],
          activeMenu: '/storeOperations/rentSale'
        }
      }, {
        hidden: true,
        path: 'HospitalGoodsListAddMenuClassify',
        name: 'HospitalGoodsListAddMenuClassify',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/rentSale/editGood.vue');
        },
        meta: {
          title: '新建租售信息',
          roles: ['HospitalGoodsListAddMenuClassify'],
          activeMenu: '/storeOperations/rentSale'
        }
      }, {
        hidden: true,
        path: 'HospitalGoodsUp',
        name: 'HospitalGoodsUp',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/rentSale/editGood.vue');
        },
        meta: {
          title: '编辑销售信息',
          roles: ['HospitalGoodsUp'],
          activeMenu: '/onlineStore/storeOperations/rentSale'
        }
      }, {
        hidden: true,
        path: 'rentSaleDetail',
        name: 'HospitalGoodsPetchDown',
        component: function component() {
          return import('@/views/onlineStore/storeOperations/rentSale/rentSaleDetail.vue');
        },
        meta: {
          title: '租售信息详情',
          roles: ['HospitalGoodsPetchDown'],
          activeMenu: '/onlineStore/storeOperations/rentSale'
        }
      }]
    }]
  }, //客户系统
  {
    path: 'customerSystem',
    name: 'CustomerSystem',
    component: function component() {
      return import('@/views/onlineStore/customerSystem');
    },
    meta: {
      title: '客户系统',
      icon: 'shop_order',
      roles: ['CustomerSystem']
    },
    children: [{
      path: 'customerManager',
      name: 'CustomerManager',
      redirect: '/onlineStore/customerSystem/customerManager/list',
      component: function component() {
        return import('@/views/onlineStore/customerSystem/customerManager/index.vue');
      },
      meta: {
        title: '客户管理',
        roles: ['CustomerManager']
      },
      children: [{
        hidden: true,
        path: 'editCustomer',
        name: 'CustomerEdit',
        component: function component() {
          return import('@/views/onlineStore/customerSystem/customerManager/editCustomer.vue');
        },
        meta: {
          title: '编辑',
          roles: ['CustomerManager', 'CustomerEdit'],
          activeMenu: '/onlineStore/customerSystem/customerManager'
        }
      }, {
        hidden: true,
        path: 'CustomerAdd',
        name: 'CustomerAdd',
        component: function component() {
          return import('@/views/onlineStore/customerSystem/customerManager/editCustomer.vue');
        },
        meta: {
          title: '新建客户',
          roles: ['CustomerManager', 'CustomerAdd'],
          activeMenu: '/onlineStore/customerSystem/customerManager'
        }
      }, {
        hidden: true,
        path: 'list',
        name: 'CustomerList',
        component: function component() {
          return import('@/views/onlineStore/customerSystem/customerManager/list.vue');
        },
        meta: {
          title: '客户列表',
          roles: ['CustomerManager', 'CustomerList'],
          activeMenu: '/onlineStore/customerSystem/customerManager',
          breadcrumb: false
        }
      }, {
        hidden: true,
        path: 'customerDetail',
        name: 'CustomerDetail',
        component: function component() {
          return import('@/views/onlineStore/customerSystem/customerManager/customerDetail.vue');
        },
        meta: {
          title: '客户详情',
          roles: ['CustomerDetail'],
          activeMenu: '/onlineStore/customerSystem/customerManager'
        }
      }]
    }]
  }, // 订单管理
  {
    path: 'orderManage',
    name: 'OrderManage',
    component: function component() {
      return import('@/views/onlineStore/orderManage');
    },
    meta: {
      title: '企业管理',
      icon: 'shop_order',
      roles: ['OrderManage', 'OrderManageList']
    },
    alwaysShow: true,
    children: [{
      path: 'list',
      name: 'OrderManageList',
      component: function component() {
        return import('@/views/onlineStore/orderManage/list.vue');
      },
      meta: {
        title: '企业列表',
        roles: ['OrderManage', 'OrderManageList']
      },
      children: [{
        path: 'detail',
        name: 'OrderManageDetail',
        hidden: true,
        component: function component() {
          return import('@/views/onlineStore/orderManage/detail.vue');
        },
        meta: {
          title: '企业详情',
          roles: ['OrderManage', 'OrderManageList'],
          activeMenu: '/onlineStore/orderManage/list'
        }
      }]
    }]
  }, // 营销管理
  {
    path: 'marketManage',
    name: 'MarketManage',
    component: function component() {
      return import('@/views/onlineStore/marketManage/');
    },
    meta: {
      title: '巡查管理',
      icon: 'nav_market',
      roles: ['MarketManage']
    },
    children: [{
      path: 'merchant',
      name: 'Merchant',
      redirect: '/onlineStore/marketManage/merchant',
      component: function component() {
        return import('@/views/onlineStore/marketManage/merchant/index.vue');
      },
      meta: {
        title: '巡查列表',
        roles: ['MerchantMarketManage']
      },
      children: [{
        path: '',
        name: 'MerchantList',
        hidden: true,
        component: function component() {
          return import('@/views/onlineStore/marketManage/merchant/list.vue');
        },
        meta: {
          title: '巡查列表',
          roles: ['MerchantMarketManage', 'CreateCouponMerchantMarketManage', 'DetailCouponMerchantMarketManage', 'MerchantReceiveRecord'],
          breadcrumb: false
        }
      } // {
      //   path: 'receiveRecord/:activityCode/:planCode/:templateCode',
      //   name: 'MerchantReceiveRecord',
      //   hidden: true,
      //   component: () => import('@/views/onlineStore/marketManage/children/receiveRecord.vue'),
      //   meta: {
      //     title: '优惠券领取记录',
      //     roles: ['MerchantReceiveRecord'],
      //     activeMenu: '/onlineStore/marketManage/merchant'
      //   }
      // },
      // {
      //   path: 'createCoupon/:storeCode?/:storeName?',
      //   name: 'MerchantCreateCoupon',
      //   hidden: true,
      //   component: () => import('@/views/onlineStore/marketManage/merchant/edit.vue'),
      //   meta: {
      //     title: '新建优惠券',
      //     roles: ['CreateCouponMerchantMarketManage'],
      //     activeMenu: '/onlineStore/marketManage/merchant'
      //   }
      // },
      // {
      //   path: 'couponDetail/:activityCode/:couponPlanCode/:storeName/:storeCode',
      //   name: 'CouponDetail',
      //   hidden: true,
      //   component: () => import('@/views/onlineStore/marketManage/children/couponDetail.vue'),
      //   meta: {
      //     title: '巡查内容详情',
      //     activeMenu: '/onlineStore/marketManage/merchant'
      //   }
      // }
      ]
    } // {
    //   path: 'platformActivity',
    //   name: 'PlatformActivity',
    //   redirect: '/onlineStore/marketManage/platformActivity',
    //   component: () => import('@/views/onlineStore/marketManage/platformActivity/index.vue'),
    //   meta: {
    //     title: '平台活动',
    //     roles: ['PlatAManage', 'PlatAManageList', 'PlatAManageDetail']
    //   },
    //   children: [
    //     {
    //       path: '',
    //       name: 'PlatformList',
    //       hidden: true,
    //       component: () => import('@/views/onlineStore/marketManage/platformActivity/list.vue'),
    //       meta: {
    //         title: '平台活动列表',
    //         roles: ['PlatAManageList', 'PlatAManageDetail'],
    //         breadcrumb: false
    //       }
    //     },
    //     {
    //       path: 'platformActivityDetail/:activityCode/:planCode/:storeCode',
    //       name: 'PlatformActivityDetail',
    //       hidden: true,
    //       component: () => import('@/views/onlineStore/marketManage/platformActivity/detail.vue'),
    //       meta: {
    //         title: '活动详情',
    //         roles: ['PlatAManageDetail'],
    //         activeMenu: '/onlineStore/marketManage/platformActivity'
    //       }
    //     },
    //     {
    //       path: 'activityCouponDetail/:activityCode/:templetCode',
    //       name: 'ActivityCouponDetail',
    //       hidden: true,
    //       component: () => import('@/views/onlineStore/marketManage/children/platCouponDetail.vue'),
    //       meta: {
    //         title: '优惠券详情',
    //         activeMenu: '/onlineStore/marketManage/platformActivity'
    //       }
    //     }
    //   ]
    // }
    ]
  }, // 客户咨询
  {
    path: 'chat',
    component: function component() {
      return import('@/views/onlineStore/chat/');
    },
    name: 'chat',
    meta: {
      title: '客户咨询',
      icon: 'nav_consult',
      roles: ['chat']
    }
  }]
}, {
  path: '/labourManager',
  name: 'LabourManager',
  component: Layout,
  redirect: '/labourManager/home',
  meta: {
    title: '劳务管理',
    breadcrumb: false,
    roles: ['LabourManager']
  },
  children: [{
    path: 'home',
    name: 'LwHome',
    component: function component() {
      return import('@/views/labourManager/home/');
    },
    meta: {
      title: '首页',
      icon: 'nav_home'
    },
    children: [{
      path: 'saleList',
      component: function component() {
        return import('@/views/labourManager/home/saleList.vue');
      },
      hidden: true,
      name: 'SaleListHome',
      meta: {
        title: '园区租售榜单',
        icon: 'nav_home',
        roles: ['PageOnlineStoreHomeGoodsList'],
        activeMenu: '/onlineStore/home'
      }
    }, {
      path: 'payList',
      component: function component() {
        return import('@/views/onlineStore/home/payList.vue');
      },
      hidden: true,
      name: 'PayListHome',
      meta: {
        title: '会员累计支付榜单',
        icon: 'nav_home',
        roles: ['OnlineStoreHome'],
        activeMenu: '/onlineStore/home'
      }
    }]
  }, // 供应商管理
  {
    path: 'supplierManager',
    name: 'LwSupplierManager',
    component: function component() {
      return import('@/views/labourManager/supplierManager/supplierInfo');
    },
    meta: {
      title: '供应商管理',
      icon: 'nav_shop',
      roles: ['LwSupplierManager']
    },
    children: [{
      path: 'supplierInfo',
      name: 'LwSupplierInfo',
      component: function component() {
        return import('@/views/labourManager/supplierManager/supplierInfo/index.vue');
      },
      redirect: '/labourManager/supplierManager/supplierInfo/list',
      meta: {
        title: '供应商信息',
        roles: ['LwSupplierInfo']
      },
      children: [{
        hidden: true,
        path: 'list',
        name: 'LwSupplierList',
        component: function component() {
          return import('@/views/labourManager/supplierManager/supplierInfo/list.vue');
        },
        meta: {
          title: '列表',
          roles: ['LwSupplierInfo', 'LwSupplierList'],
          activeMenu: '/labourManager/supplierManager/supplierInfo',
          breadcrumb: false
        }
      }, {
        hidden: true,
        path: 'supplierInfoEdit',
        name: 'LwSupplierEdit',
        component: function component() {
          return import('@/views/labourManager/supplierManager/supplierInfo/editSupplierInfo.vue');
        },
        meta: {
          title: '编辑',
          roles: ['LwSupplierEdit'],
          activeMenu: '/labourManager/supplierManager/supplierInfo'
        }
      }, {
        hidden: true,
        path: 'supplierInfoAdd',
        name: 'LwSupplierAdd',
        component: function component() {
          return import('@/views/labourManager/supplierManager/supplierInfo/editSupplierInfo.vue');
        },
        meta: {
          title: '添加',
          roles: ['LwSupplierAdd'],
          activeMenu: '/labourManager/supplierManager/supplierInfo'
        }
      }, {
        hidden: true,
        path: 'supplierInfoDetail',
        name: 'LwSupplierDetail',
        component: function component() {
          return import('@/views/labourManager/supplierManager/supplierInfo/supplierInfoDetail.vue');
        },
        meta: {
          title: '详情',
          roles: ['LwSupplierDetail'],
          activeMenu: '/labourManager/supplierManager/supplierInfo'
        }
      }]
    }]
  }, // 用工单位管理
  {
    path: 'employManager',
    name: 'LwEnterpriseManager',
    component: function component() {
      return import('@/views/labourManager/employManager/enterpriseManager');
    },
    meta: {
      title: '用工单位',
      icon: 'nav_market',
      roles: ['LwEnterpriseManager']
    },
    children: [{
      path: 'enterpriseManager',
      name: 'LwEnterprise',
      redirect: '/labourManager/employManager/enterpriseManager',
      component: function component() {
        return import('@/views/labourManager/employManager/enterpriseManager/index.vue');
      },
      meta: {
        title: '用工单位管理',
        roles: ['LwEnterprise']
      },
      children: [{
        hidden: true,
        path: '',
        name: 'LwEnterpriseList',
        component: function component() {
          return import('@/views/labourManager/employManager/enterpriseManager/list.vue');
        },
        meta: {
          title: '用工单位列表',
          roles: ['LwEnterpriseList'],
          breadcrumb: false
        }
      }, {
        path: 'editEnterprise',
        name: 'LwEnterpriseAdd',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/employManager/enterpriseManager/editEnterprise.vue');
        },
        meta: {
          title: '添加',
          roles: ['LwEnterpriseAdd'],
          breadcrumb: false
        }
      }, {
        path: 'editEnterprise',
        name: 'LwEnterpriseEdit',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/employManager/enterpriseManager/editEnterprise.vue');
        },
        meta: {
          title: '编辑',
          roles: ['LwEnterpriseEdit'],
          breadcrumb: false
        }
      }, {
        path: 'receiveRecord/:activityCode/:planCode/:templateCode',
        name: 'MerchantReceiveRecord',
        hidden: true,
        component: function component() {
          return import('@/views/onlineStore/marketManage/children/receiveRecord.vue');
        },
        meta: {
          title: '优惠券领取记录',
          roles: ['MerchantReceiveRecord'],
          activeMenu: '/onlineStore/marketManage/merchant'
        }
      }, {
        path: 'createCoupon/:storeCode?/:storeName?',
        name: 'MerchantCreateCoupon',
        hidden: true,
        component: function component() {
          return import('@/views/onlineStore/marketManage/merchant/edit.vue');
        },
        meta: {
          title: '新建优惠券',
          roles: ['CreateCouponMerchantMarketManage'],
          activeMenu: '/onlineStore/marketManage/merchant'
        }
      }, {
        path: 'couponDetail/:activityCode/:couponPlanCode/:storeName/:storeCode',
        name: 'CouponDetail',
        hidden: true,
        component: function component() {
          return import('@/views/onlineStore/marketManage/children/couponDetail.vue');
        },
        meta: {
          title: '优惠券详情',
          activeMenu: '/onlineStore/marketManage/merchant'
        }
      }]
    }, {
      path: 'postManager',
      name: 'LwPostManager',
      redirect: '/labourManager/employManager/postManager',
      component: function component() {
        return import('@/views/labourManager/employManager/postManager/index.vue');
      },
      meta: {
        title: '岗位管理',
        roles: ['LwPostManager']
      },
      children: [{
        hidden: true,
        path: '',
        name: 'PostList',
        component: function component() {
          return import('@/views/labourManager/employManager/postManager/list.vue');
        },
        meta: {
          title: '岗位列表',
          roles: ['PostList'],
          breadcrumb: false
        }
      }, {
        path: 'editPost',
        name: 'PostAdd',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/employManager/postManager/editPost.vue');
        },
        meta: {
          title: '添加',
          roles: ['PostAdd'],
          breadcrumb: false
        }
      }, {
        path: 'editPost',
        name: 'PostUpdate',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/employManager/postManager/editPost.vue');
        },
        meta: {
          title: '编辑',
          roles: ['PostUpdate'],
          breadcrumb: false
        }
      }, {
        path: 'receiveRecord/:activityCode/:planCode/:templateCode',
        name: 'MerchantReceiveRecord',
        hidden: true,
        component: function component() {
          return import('@/views/onlineStore/marketManage/children/receiveRecord.vue');
        },
        meta: {
          title: '优惠券领取记录',
          roles: ['MerchantReceiveRecord'],
          activeMenu: '/onlineStore/marketManage/merchant'
        }
      }]
    }]
  }, //   // 应聘者管理
  {
    path: 'labourUserManager',
    name: 'LabourUserManager',
    component: function component() {
      return import('@/views/labourManager/labourUserManager/labourUserInfo');
    },
    meta: {
      title: '应聘者管理',
      icon: 'nav_shop',
      roles: ['LabourUserManager']
    },
    children: [{
      path: 'labourUserInfo',
      name: 'LabourUserInfo',
      component: function component() {
        return import('@/views/labourManager/labourUserManager/labourUserInfo/index.vue');
      },
      redirect: '/labourManager/labourUserManager/labourUserInfo/list',
      meta: {
        title: '应聘者信息',
        roles: ['LabourUserInfo']
      },
      children: [{
        hidden: true,
        path: 'list',
        name: 'UserInfoList',
        component: function component() {
          return import('@/views/labourManager/labourUserManager/labourUserInfo/list.vue');
        },
        meta: {
          title: '应聘者列表',
          roles: ['LabourUserInfo', 'UserInfoList'],
          activeMenu: '/labourManager/labourUserManager/labourUserInfo',
          breadcrumb: false
        }
      }, {
        hidden: true,
        path: 'labourUserEdit',
        name: 'LabourUserEdit',
        component: function component() {
          return import('@/views/labourManager/labourUserManager/labourUserInfo/editLabourUser.vue');
        },
        meta: {
          title: '编辑',
          roles: ['LabourUserEdit'],
          activeMenu: '/labourManager/labourUserManager/labourUserInfo'
        }
      }, {
        hidden: true,
        path: 'labourUserAdd',
        name: 'LabourUserAdd',
        component: function component() {
          return import('@/views/labourManager/labourUserManager/labourUserInfo/editLabourUser.vue');
        },
        meta: {
          title: '新建应聘者',
          roles: ['LabourUserAdd'],
          activeMenu: '/labourManager/labourUserManager/labourUserInfo'
        }
      }, {
        hidden: true,
        path: 'labourUserDetail',
        name: 'LabourUserDetail',
        component: function component() {
          return import('@/views/labourManager/labourUserManager/labourUserInfo/labourUserDetail.vue');
        },
        meta: {
          title: '应聘者详情',
          roles: ['LabourUserDetail'],
          activeMenu: '/labourManager/labourUserManager/labourUserInfo'
        }
      }]
    }, {
      path: 'labourInterview',
      name: 'InterviewManage',
      component: function component() {
        return import('@/views/labourManager/labourUserManager/labourInterview/index.vue');
      },
      redirect: '/labourManager/labourUserManager/labourInterview/list',
      meta: {
        title: '面试管理',
        roles: ['InterviewManage']
      },
      children: [{
        hidden: true,
        path: 'list',
        name: 'InterviewList',
        component: function component() {
          return import('@/views/labourManager/labourUserManager/labourInterview/list.vue');
        },
        meta: {
          title: '面试列表',
          roles: ['InterviewList'],
          activeMenu: '/labourManager/labourUserManager/labourInterview',
          breadcrumb: false
        }
      }, {
        hidden: true,
        path: 'editLabourInterview',
        name: 'InterviewUpdate',
        component: function component() {
          return import('@/views/labourManager/labourUserManager/labourInterview/editLabourInterview.vue');
        },
        meta: {
          title: '编辑',
          roles: ['InterviewUpdate'],
          activeMenu: '/labourManager/labourUserManager/labourInterview'
        }
      }, {
        hidden: true,
        path: 'editLabourInterview',
        name: 'LabourInterviewAdd',
        component: function component() {
          return import('@/views/labourManager/labourUserManager/labourInterview/editLabourInterview.vue');
        },
        meta: {
          title: '添加',
          roles: ['LabourInterviewAdd'],
          activeMenu: '/labourManager/labourUserManager/labourInterview'
        }
      }, {
        hidden: true,
        path: 'labourInterviewDetail',
        name: 'InterviewDetail',
        component: function component() {
          return import('@/views/labourManager/labourUserManager/labourInterview/labourInterviewDetail.vue');
        },
        meta: {
          title: '面试详情',
          roles: ['InterviewDetail'],
          activeMenu: '/labourManager/labourUserManager/labourInterview'
        }
      }]
    }]
  }, //合同管理
  {
    path: 'contractManager',
    name: 'LwContractManager',
    component: function component() {
      return import('@/views/labourManager/contractManager/recuitContract');
    },
    meta: {
      title: '合同管理',
      icon: 'nav_market',
      roles: ['LwContractManager']
    },
    children: [{
      path: 'recuitContract',
      name: 'LwRecruitContract',
      redirect: '/labourManager/contractManager/recuitContract',
      component: function component() {
        return import('@/views/labourManager/contractManager/recuitContract/index.vue');
      },
      meta: {
        title: '用工合同管理',
        roles: ['LwRecruitContract']
      },
      children: [{
        hidden: true,
        path: '',
        name: 'LwRecuitList',
        component: function component() {
          return import('@/views/labourManager/contractManager/recuitContract/list.vue');
        },
        meta: {
          title: '用工合同列表',
          roles: ['LwRecuitList'],
          breadcrumb: false
        }
      }, {
        path: 'editRecuitContract',
        name: 'LwRecuitAdd',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/contractManager/recuitContract/editRecuitContract.vue');
        },
        meta: {
          title: '添加',
          roles: ['LwRecuitAdd'],
          breadcrumb: false
        }
      }, {
        path: 'editRecuitContract',
        name: 'LwRecuitUpdate',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/contractManager/recuitContract/editRecuitContract.vue');
        },
        meta: {
          title: '编辑',
          roles: ['LwRecuitUpdate'],
          breadcrumb: false
        }
      }, {
        path: 'recuitContractDetail',
        name: 'LwRecuitDetail',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/contractManager/recuitContract/recuitContractDetail.vue');
        },
        meta: {
          title: '详情',
          roles: ['LwRecuitDetail'],
          breadcrumb: false
        }
      }]
    }, {
      path: 'employContract',
      name: 'LwEmployManager',
      redirect: '/labourManager/contractManager/employContract',
      component: function component() {
        return import('@/views/labourManager/contractManager/employContract/index.vue');
      },
      meta: {
        title: '员工合同管理',
        roles: ['LwEmployManager']
      },
      children: [{
        hidden: true,
        path: '',
        name: 'LwEmpContractList',
        component: function component() {
          return import('@/views/labourManager/contractManager/employContract/list.vue');
        },
        meta: {
          title: '列表',
          roles: ['LwEmpContractList'],
          breadcrumb: false
        }
      }, {
        path: 'editEmployContract',
        name: 'LwEmpContractAdd',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/contractManager/employContract/editEmployContract.vue');
        },
        meta: {
          title: '添加',
          roles: ['LwEmpContractAdd'],
          breadcrumb: false
        }
      }, {
        path: 'editEmployContract',
        name: 'LwEmpUpdate',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/contractManager/employContract/editEmployContract.vue');
        },
        meta: {
          title: '编辑',
          roles: ['LwEmpUpdate'],
          breadcrumb: false
        }
      }, {
        path: 'employContractDetail',
        name: 'LwEmpContractDetail',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/contractManager/employContract/employContractDetail.vue');
        },
        meta: {
          title: '详情',
          roles: ['LwEmpContractDetail'],
          breadcrumb: false
        }
      }]
    }]
  }, //招聘管理
  {
    path: 'zhaopinManager',
    name: 'LwZhaopinManager',
    component: function component() {
      return import('@/views/labourManager/zhaopinManager/zhaopinInfo');
    },
    meta: {
      title: '招聘管理',
      icon: 'nav_market',
      roles: ['LwZhaopinManager']
    },
    children: [{
      path: 'zhaopinInfo',
      name: 'LwZhaopinInfo',
      redirect: '/labourManager/zhaopinManager/zhaopinInfo',
      component: function component() {
        return import('@/views/labourManager/zhaopinManager/zhaopinInfo/index.vue');
      },
      meta: {
        title: '招聘信息',
        roles: ['LwZhaopinInfo']
      },
      children: [{
        hidden: true,
        path: '',
        name: 'LwZhaopinInfoList',
        component: function component() {
          return import('@/views/labourManager/zhaopinManager/zhaopinInfo/list.vue');
        },
        meta: {
          title: '招聘信息列表',
          roles: ['LwZhaopinInfoList'],
          breadcrumb: false
        }
      }, {
        path: 'editZhaopingInfo',
        name: 'LwZhaopinAdd',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/zhaopinManager/zhaopinInfo/editZhaopinInfo.vue');
        },
        meta: {
          title: '添加',
          roles: ['LwZhaopinAdd'],
          breadcrumb: false
        }
      }, {
        path: 'editZhaopingInfo',
        name: 'LwZhaopinInfoEdit',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/zhaopinManager/zhaopinInfo/editZhaopinInfo.vue');
        },
        meta: {
          title: '编辑',
          roles: ['LwZhaopinInfoEdit'],
          breadcrumb: false
        }
      }, {
        path: 'zhaopinInfoDetail',
        name: 'LwZhaopinInfoDetail',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/zhaopinManager/zhaopinInfo/zhaopinInfoDetail.vue');
        },
        meta: {
          title: '详情',
          roles: ['LwZhaopinInfoDetail'],
          breadcrumb: false
        }
      }]
    }]
  }, //财务管理
  {
    path: 'salaryManager',
    name: 'LwSalaryManager',
    component: function component() {
      return import('@/views/labourManager/salaryManager/empSalary');
    },
    meta: {
      title: '财务管理',
      icon: 'nav_market',
      roles: ['LwSalaryManager']
    },
    children: [{
      path: 'empSalary',
      name: 'LwEmpSalary',
      redirect: '/labourManager/salaryManager/empSalary',
      component: function component() {
        return import('@/views/labourManager/salaryManager/empSalary/index.vue');
      },
      meta: {
        title: '派遣员工工资',
        roles: ['LwEmpSalary']
      },
      children: [{
        hidden: true,
        path: '',
        name: 'LwEmpSalaryList',
        component: function component() {
          return import('@/views/labourManager/salaryManager/empSalary/list.vue');
        },
        meta: {
          title: '列表',
          roles: ['LwEmpSalaryList'],
          breadcrumb: false
        }
      }, {
        path: 'editEmpSalary',
        name: 'LwEmpSalaryAdd',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/salaryManager/empSalary/editEmpSalary.vue');
        },
        meta: {
          title: '添加',
          roles: ['LwEmpSalaryAdd'],
          breadcrumb: false
        }
      }, {
        path: 'editEmpSalary',
        name: 'LwEmpSalaryUpdate',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/salaryManager/empSalary/editEmpSalary.vue');
        },
        meta: {
          title: '编辑',
          roles: ['LwEmpSalaryUpdate'],
          breadcrumb: false
        }
      }, {
        path: 'empSalaryDetail',
        name: 'LwEmpSalaryDetail',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/salaryManager/empSalary/empSalaryDetail.vue');
        },
        meta: {
          title: '详情',
          roles: ['LwEmpSalaryDetail'],
          breadcrumb: false
        }
      }]
    }, {
      path: 'supplierSalary',
      name: 'LwSupplierSalary',
      redirect: '/labourManager/salaryManager/supplierSalary',
      component: function component() {
        return import('@/views/labourManager/salaryManager/supplierSalary/index.vue');
      },
      meta: {
        title: '供应商工资',
        roles: ['LwSupplierSalary']
      },
      children: [{
        hidden: true,
        path: '',
        name: 'LwSSalaryList',
        component: function component() {
          return import('@/views/labourManager/salaryManager/supplierSalary/list.vue');
        },
        meta: {
          title: '列表',
          roles: ['LwSSalaryList'],
          breadcrumb: false
        }
      }, {
        path: 'editSupplierSalary',
        name: 'LwSSalaryAdd',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/salaryManager/supplierSalary/editSupplierSalary.vue');
        },
        meta: {
          title: '添加',
          roles: ['LwSSalaryAdd'],
          breadcrumb: false
        }
      }, {
        path: 'editSupplierSalary',
        name: 'LwSSalaryUpdate',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/salaryManager/supplierSalary/editSupplierSalary.vue');
        },
        meta: {
          title: '编辑',
          roles: ['LwSSalaryUpdate'],
          breadcrumb: false
        }
      }, {
        path: 'supplierSalaryDetail',
        name: 'LwSSalaryDetail',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/salaryManager/supplierSalary/supplierSalaryDetail.vue');
        },
        meta: {
          title: '详情',
          roles: ['LwSSalaryDetail'],
          breadcrumb: false
        }
      }]
    }, {
      path: 'advanceSalary',
      name: 'LwAdvanceSalary',
      redirect: '/labourManager/salaryManager/advanceSalary',
      component: function component() {
        return import('@/views/labourManager/salaryManager/advanceSalary/index.vue');
      },
      meta: {
        title: '预支工资',
        roles: ['LwAdvanceSalary']
      },
      children: [{
        hidden: true,
        path: '',
        name: 'LwASalaryList',
        component: function component() {
          return import('@/views/labourManager/salaryManager/advanceSalary/list.vue');
        },
        meta: {
          title: '列表',
          roles: ['LwASalaryList'],
          breadcrumb: false
        }
      }, {
        path: 'editAdvanceSalary',
        name: 'LwASalaryAdd',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/salaryManager/advanceSalary/editAdvanceSalary.vue');
        },
        meta: {
          title: '添加',
          roles: ['LwASalaryAdd'],
          breadcrumb: false
        }
      }, {
        path: 'editAdvanceSalary',
        name: 'LwASalaryUpdate',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/salaryManager/advanceSalary/editAdvanceSalary.vue');
        },
        meta: {
          title: '编辑',
          roles: ['LwSSalaryUpdate'],
          breadcrumb: false
        }
      }, {
        path: 'advanceSalaryDetail',
        name: 'LwASalaryDetail',
        hidden: true,
        component: function component() {
          return import('@/views/labourManager/salaryManager/advanceSalary/advanceSalaryDetail.vue');
        },
        meta: {
          title: '详情',
          roles: ['LwASalaryDetail'],
          breadcrumb: false
        }
      }]
    }]
  }, // 客户咨询
  {
    path: 'chat',
    component: function component() {
      return import('@/views/onlineStore/chat/');
    },
    name: 'chat',
    meta: {
      title: '客户咨询',
      icon: 'nav_consult',
      roles: ['chat']
    }
  }]
}, // 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];

var createRouter = function createRouter() {
  return new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_ROUTE_BASE,
    scrollBehavior: function scrollBehavior() {
      return {
        x: 0,
        y: 0
      };
    },
    routes: constantRoutes
  });
};

var router = createRouter(); // 重置路由

export var resetRouter = function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router

  console.log("router.matcher ----->>>", router.matcher);
};
export default router;